// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2hkwI","buttons":"RemoveExpirationActionButtons_buttons__3gpdT"};